import { IconType } from 'react-icons';
import * as FaIcons from 'react-icons/fa';

/** Prefix marking an icon string as a monogram fallback (e.g. "mono:Attio") for brands with no
 *  logo. Rendered as the brand initial by BrandGlyph. */
export const MONOGRAM_PREFIX = 'mono:';

/** First letter of a brand name, for the monogram fallback. */
export const monogramLabel = (value: string): string => {
  const name = value.startsWith(MONOGRAM_PREFIX) ? value.slice(MONOGRAM_PREFIX.length) : value;
  return name.trim().charAt(0).toUpperCase();
};

/** Resolve an action `icon` string to a react-icons Font Awesome component, used by the icon picker
 *  for non-MCP action types. MCP catalog brands render their real logo via BrandGlyph instead, so
 *  this returns undefined for their "logo:<domain>" markers (and for monograms / unknown names). */
export const resolveActionIcon = (name: string): IconType | undefined =>
  // eslint-disable-next-line import/namespace
  (FaIcons as Record<string, IconType>)[name] as IconType | undefined;
